import React, { useEffect, useState } from 'react';
import webSocket from 'socket.io-client'

import { Blank } from './Blank';
import { AdminPageAdd } from "../Admin/Menu/PageAdd"
import { AdminMenuAdd } from "../Admin/Menu/MenuAdd"
import { ManagerAdd } from "../Admin/Manager/ManagerAdd"
import { AdminCompanyList } from "../Admin/Company/CompanyList"
import { AdminRoleList } from "../Admin/Role/RoleList"
import { AdminRoleAdd } from "../Admin/Role/RoleAdd"
import { EmployeeList } from "../Content/Employee/EmployeeList"
import { CompanyList } from "../Content/Company/CompanyList"
import { CompanyAdd } from "../Content/Company/CompanyAdd"
import { AdminPermissionList } from '../Admin/Permission/PermissionList';
import { setPageLink, getMainPageList } from '../../Menu/MenuConfig';
import { ContractorResumeEdit } from './ContractorResume/ContractorResumeEdit';
import { ContractorResumeAdd } from './ContractorResume/ContractorResumeAdd';
import { ContentHeader } from './ContentHeader';
import { ContractorResumeList } from './ContractorResume/ContractorResumeList';
import { EmployeeResumeAdd } from './EmployeeResume/EmployeeResumeAdd';
import { EmployeeResumeList } from './EmployeeResume/EmployeeResumeList';
import { EmployeeResumeEdit } from './EmployeeResume/EmployeeResumeEdit';
import { AccountList } from '../Admin/Account/AccountList';
import { AccountAdd } from '../Admin/Account/AccountAdd';
import { AccountDetail } from '../Admin/Account/AccountDetail';
import { Page404 } from './Page404';
import { AdminDepartmentList } from '../Admin/Department/AdminDepartmentList';
import { DepartmentList } from './Department/DepartmentList';
import { DepartmentAdd } from './Department/DepartmentAdd';
import { DepartmentDetail } from './Department/DepartmentDetail';
import { DepartmentPositionAdd } from './Department/DepartmentPositionAdd';
import { DepartmentPositionEdit } from './Department/DepartmentPositionEdit';
import { DepartmentPositionPermission } from './Department/DepartmentPositionPermission';
import { CompanyDetail } from './Company/CompanyDetail';
import { CategoryList } from '../Admin/Category/CategoryList';
import { CustomerContractList } from './CustomerContract/CustomerContractList';
import { CustomerContractEdit } from './CustomerContract/CustomerContractEdit';
import { CategoryEdit } from '../Admin/Category/CategoryEdit';
import { ClientAdminList } from '../Admin/Manager/ClientAdminList';
import { ClientAdminAdd } from '../Admin/Manager/ClientAdminAdd';
import { ClientAdminDetail } from '../Admin/Manager/ClientAdminDetail';
import { ClientAdminEdit } from '../Admin/Manager/ClientAdminEdit';
import { CustomerPositionEdit } from './CustomerPosition/CustomerPositionEdit';
import { PositionDemandList } from './PositionDemand/PositionDemandList';
import { PositionDemandEdit } from './PositionDemand/PositionDemandEdit';
import { SOCKETIO_URL } from '../../../config';
import { setWebSocketConnect, getWebSocketConnect } from '../../Login/doitSocket';
import { RecruitmentContractorStatusList } from './RecruitmentContractorStatus/RecruitmentContractorStatusList';
import { RecruitmentContractorStatusDetail } from './RecruitmentContractorStatus/RecruitmentContractorStatusDetail';
import { ReserveSOP } from './RecruitmentContractorStatus/ReserveSOP';
import { IsOrNotOnboardSOP } from './RecruitmentContractorStatus/IsOrNotOnboardSOP';
import { RecruitmentPerformanceContractorRelatedList } from './RecruitmentPerformance/RecruitmentPerformanceContractorRelatedList';
import { ResignSOP } from './RecruitmentContractorStatus/ResignSOP';
import { RecruitmentPerformanceSpecialistList } from './RecruitmentPerformance/RecruitmentPerformanceSpecialistList';
import { RecruitmentPerformanceDepartmentList } from './RecruitmentPerformance/RecruitmentPerformanceDepartmentList';
import { ReviseSOPCaseStatus1 } from './ReviseSOP/ReviseSOPCaseStatus1';
import { ReviseSOPCaseStatus2 } from './ReviseSOP/ReviseSOPCaseStatus2';
import { ReviseSOPCaseStatus3 } from './ReviseSOP/ReviseSOPCaseStatus3';
import { ReviseSOPCaseStatus4 } from './ReviseSOP/ReviseSOPCaseStatus4';
import { InsuranceReviseSOP } from './ReviseSOP/InsuranceReviseSOP';
import { ContractorEnrollList } from './RecruitmentContractorInsurance/ContractorEnrollList';
import { ContractorAttendanceSOPList } from './ContractorAttendance/ContractorAttendanceSOPList';
import { ContractorAttendanceSOPAdd } from './ContractorAttendance/ContractorAttendanceSOPAdd';
import { ContractorAttendanceEdit } from './ContractorAttendance/ContractorAttendanceEdit';
import { ContractorAttendanceRegisterMonthly } from './ContractorAttendance/ContractorAttendanceRegisterMonthly';
import { ContractorAttendanceRegisterHourly } from './ContractorAttendance/ContractorAttendanceRegisterHourly';
import { ContractorInsuranceCost } from './ContractorAttendance/ContractorInsuranceCost';
import { MoudleList } from '../Admin/Module/ModuleList';
import { ModuleEdit } from '../Admin/Module/ModuleEdit';
import { ModulePermissionList } from '../Admin/ModulePermission/ModulePermissionList';
import { ModulePermissionEdit } from '../Admin/ModulePermission/ModulePermissionEdit';
import { LeagueList } from './MyStat/League/LeagueList';
import { LeagueEdit } from './MyStat/League/LeagueEdit';
import { UMPList } from './MyStat/Umpire/UMPList';
import { UMPEdit } from './MyStat/Umpire/UMPEdit';
import { ParkList } from './MyStat/Park/ParkList';
import { ParkEdit } from './MyStat/Park/ParkEdit';
import { PlayerList } from './MyStat/Player/PlayerList';
import { PlayerEdit } from './MyStat/Player/PlayerEdit';
import { TeamList } from './MyStat/Team/TeamList';
import { TeamEdit } from './MyStat/Team/TeamEdit';
import { RetailList } from './Beer/BeerRetail/BeerRetailList';
import { PURVIEW_DISTRIBUTOR, PURVIEW_MANAGER, PURVIEW_SPECIALIST } from '../../../item/Beer/ItemRetail';
import { RetailEdit } from './Beer/BeerRetail/BeerRetailEdit';
import { GameList } from './MyStat/Game/GameList';
import { GameEdit } from './MyStat/Game/GameEdit';
import { ActionList } from './MyStat/Game/Action_List';
import { ClientList } from './MyStat/Client/ClientList';
import { ClientAdd } from './MyStat/Client/ClientAdd';
import { BallModifyList } from './MyStat/Game/BallModifyList';

export function Content({ Page, pathname, pathArray, setIsLoading }) {
    const [PathArray, setPathArray] = useState([])
    const [pageList, setPageList] = useState([])

    const [ws, setWs] = useState(null)

    // useEffect(()=>{
    //     console.log("A")
    //     //connectWebSocket()
    // },[])

    // const  connectWebSocket = async() => {
    //     //開啟
    //     //setWs(webSocket(SOCKETIO_URL))
    //     await setWebSocketConnect(webSocket(SOCKETIO_URL)) 
    //     if(getWebSocketConnect()){
    //         console.log('success connect!')
    //         //設定監聽
    //         initWebSocket()
    //     }
    // }



    // const initWebSocket = () => {
    //     //對 getMessage 設定監聽，如果 server 有透過 getMessage 傳送訊息，將會在此被捕捉
    //     getWebSocketConnect().on('getMessage', message => {
    //         console.log(message)
    //     })
    // }

    // const sendMessage = () => {
    //     if(ws){
    //         console.log("send")
    //         //以 emit 送訊息，並以 getMessage 為名稱送給 server 捕捉
    //         ws.emit('getMessage', '只回傳給發送訊息的 client')
    //     }else{
    //         connectWebSocket()
    //     }
    // }

    useEffect(() => {
        if (pathArray !== undefined && pathArray !== '' && pathArray.length > 0 && pathArray[0] !== '' && pathArray !== PathArray) {
            setPathArray(pathArray)
            setPageList(getMainPageList())
        }

    }, [pathArray])

    //var pathArray = props.location.pathname.split("").slice(1)

    var content = <Blank />
    var headerName, headerDescription, breadcrumbs

    var path = PathArray.length > 0 ? PathArray[0] : ""
    setPageLink(path)
    var filterEmpty = pageList.filter(function (page, index, array) {
        //console.log(page)
        return page.pageLink === path;
    });

    // console.log(PathArray)
    //  console.log(path)
    //  console.log(pageList)
    //  console.log(filterEmpty)

    if (PathArray.length > 0) {
        if (filterEmpty.length === 0 && path !== "main") {
            content = <Page404 />
        } else {
            var parameter = ""
            try {
                parameter = PathArray[1]
            } catch (error) {

            }
            switch (path) {
                case "AdminPageAdd":
                    content = <AdminPageAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "AdminMenuAdd":
                    content = <AdminMenuAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ClientAdminList":
                    headerName = "申請人列表"
                    breadcrumbs = ["系統管理", "申請人管理", "申請資料及所屬公司"]
                    content = <ClientAdminList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ClientAdminAdd":
                    headerName = "申請人新增"
                    breadcrumbs = ["系統管理", "申請人管理", "申請資料及所屬公司"]
                    content = <ClientAdminAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                // case "ClientAdminEdit":
                //     content = <ManagerAdd />
                //     break;
                case "AdminPermissionList":
                    content = <AdminPermissionList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "AdminRoleAdd":
                    content = <AdminRoleAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ModuleList":
                    content = <MoudleList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ModuleAdd":
                    breadcrumbs = ["系統管理", "功能模組管理", "新增模組"]
                    content = <ModuleEdit id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ModuleEdit":
                    breadcrumbs = ["系統管理", "功能模組管理", "修改模組"]
                    content = <ModuleEdit id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ModulePermissionList":
                    breadcrumbs = ["申請人管理", "申請人模組授權", "申請人模組列表"]
                    content = <ModulePermissionList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ModulePermissionEdit":
                    breadcrumbs = ["申請人管理", "申請人模組授權", "申請人模組管理"]
                    content = <ModulePermissionEdit id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "PageCategoryList":
                    breadcrumbs = ["系統管理", "頁面及選單設定", "類別設定"]
                    content = <CategoryList id={parameter} type={"Page"} setIsLoading={setIsLoading} />
                    break;
                case "PageCategoryAdd":
                    breadcrumbs = ["系統管理", "頁面及選單設定", "類別設定"]
                    content = <CategoryEdit id={parameter} type={"Page"} setIsLoading={setIsLoading} />
                    break;
                case "PageCategoryEdit":
                    breadcrumbs = ["系統管理", "頁面及選單設定", "類別設定"]
                    content = <CategoryEdit id={parameter} type={"Page"}  setIsLoading={setIsLoading} />
                    break;
                case "DepartmentCategoryList":
                    breadcrumbs = ["系統管理", "頁面及選單設定", "類別設定"]
                    content = <CategoryList id={parameter} type={"Department"} setIsLoading={setIsLoading} />
                    break;
                case "DepartmentCategoryAdd":
                    breadcrumbs = ["系統管理", "頁面及選單設定", "類別設定"]
                    content = <CategoryEdit id={parameter} type={"Department"} setIsLoading={setIsLoading} />
                    break;
                case "DepartmentCategoryEdit":
                    breadcrumbs = ["系統管理", "頁面及選單設定", "類別設定"]
                    content = <CategoryEdit id={parameter} type={"Department"}  setIsLoading={setIsLoading} />
                    break;
                case "AccountList":
                    breadcrumbs = ["系統管理", "系統帳號", "帳號列表"]
                    content = <AccountList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "AccountAdd":
                    breadcrumbs = ["系統管理", "系統帳號", "帳號新增"]
                    content = <AccountAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "EmployeeList":
                    content = <EmployeeList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "CompanyList":
                    headerName = "公司列表"
                    breadcrumbs = ["基礎設定", "公司管理", "所屬公司"]
                    content = <CompanyList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "CompanyAdd":
                    headerName = "公司新增"
                    breadcrumbs = ["基礎設定", "公司管理", "所屬公司"]
                    content = <CompanyAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "DepartmentList":
                    headerName = "部門列表"
                    breadcrumbs = ["基礎設定", "職務權限管理", "公司組織管理"]
                    content = <DepartmentList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "DepartmentAdd":
                    headerName = "部門新增"
                    breadcrumbs = ["基礎設定", "職務權限管理", "公司組織管理"]
                    content = <DepartmentAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorResumeList":
                    headerName = "外派員工列表"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "外派員工履歷表"]
                    content = <ContractorResumeList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorResumeAdd":
                    headerName = "外派員工新增"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "外派員工履歷表"]
                    content = <ContractorResumeAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "EmployeeResumeList":
                    headerName = "員工列表"
                    breadcrumbs = ["資料庫管理", "員工資料庫", "員工履歷表"]
                    content = <EmployeeResumeList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "EmployeeResumeAdd":
                    headerName = "員工新增"
                    breadcrumbs = ["資料庫管理", "員工資料庫", "員工履歷表"]
                    content = <EmployeeResumeAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "CustomerContractList":
                    headerName = "廠商合約列表"
                    breadcrumbs = ["資料庫管理", "廠商合約資料庫", "廠商合約管理"]
                    content = <CustomerContractList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "CustomerContractAdd":
                    headerName = "廠商合約新增"
                    breadcrumbs = ["資料庫管理", "廠商合約資料庫", "廠商合約管理"]
                    content = <CustomerContractEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} isAdd={true} />
                    break;
                case "PositionDemandList":
                    headerName = "職缺需求列表"
                    breadcrumbs = ["工作區", "招募主管", "職缺需求"]
                    content = <PositionDemandList id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} />
                    break;
                case "PositionDemandList_ML":
                    headerName = "職缺需求列表"
                    breadcrumbs = ["工作區", "招募主管", "職缺需求"]
                    content = <PositionDemandList id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} isML={true} />
                    break;
                case "RecruitmentContractorStatusList":
                    headerName = "外派員工工作狀態列表"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "非就業中-外派員工"]
                    content = <RecruitmentContractorStatusList id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} />
                    break;
                case "RecruitmentContractorStatusList_All":
                    headerName = "外派員工工作狀態列表"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "全部-外派員工工作狀態"]
                    content = <RecruitmentContractorStatusList id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} isAll={true} />
                    break;
                case "RecruitmentContractorStatusList_ML":
                    headerName = "外派員工工作狀態列表"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "非就業中-外派員工"]
                    content = <RecruitmentContractorStatusList id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} isML={true} />
                    break;
                case "RecruitmentPerformance_ContractorRelatedList":
                    headerName = "招募績效及關係人員列表"
                    breadcrumbs = ["工作區", "招募績效管理", "招募績效及關係人員狀態列表"]
                    content = <RecruitmentPerformanceContractorRelatedList id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} />
                    break;
                case "RecruitmentPerformance_SpecialistList":
                    headerName = "招募績效及部門成員績效列表"
                    breadcrumbs = ["工作區", "招募績效管理", "部門績效管理"]
                    content = <RecruitmentPerformanceSpecialistList id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} />
                    break;
                case "RecruitmentPerformance_DepartmentList":
                    headerName = "招募績效及部門績效列表"
                    breadcrumbs = ["工作區", "招募績效管理", "公司績效管理"]
                    content = <RecruitmentPerformanceDepartmentList id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} />
                    break;
                case "ClientAdminDetail":
                    headerName = "申請人檢視"
                    breadcrumbs = ["系統管理", "申請人管理", "申請資料及所屬公司"]
                    content = <ClientAdminDetail id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ClientAdminEdit":
                    console.log("AdminEdit")
                    headerName = "申請人編輯"
                    breadcrumbs = ["系統管理", "申請人管理", "申請資料及所屬公司"]
                    content = <ClientAdminEdit id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "AccountDetail":
                    headerName = "帳號檢視"
                    breadcrumbs = ["系統管理", "系統帳號", "帳號檢視"]
                    content = <AccountDetail id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "AccountEdit":
                    headerName = "帳號編輯"
                    breadcrumbs = ["系統管理", "系統帳號", "帳號檢視"]
                    content = <AccountDetail id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "AdminCompanyList":
                    content = <AdminCompanyList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "AdminDepartmentList":
                    content = <AdminDepartmentList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "AdminRoleList":
                    content = <AdminRoleList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "CompanyDetail":
                    headerName = "公司檢視"
                    breadcrumbs = ["基礎設定", "公司管理", "所屬公司"]
                    content = <CompanyDetail id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "CompanyEdit":
                    headerName = "公司編輯"
                    breadcrumbs = ["基礎設定", "公司管理", "所屬公司"]
                    content = <CompanyDetail id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "DepartmentDetail":
                    headerName = "部門檢視"
                    breadcrumbs = ["基礎設定", "職務權限管理", "公司組織管理"]
                    content = <DepartmentDetail id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "DepartmentEdit":
                    headerName = "部門編輯"
                    breadcrumbs = ["基礎設定", "職務權限管理", "公司組織管理"]
                    content = <DepartmentDetail id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                // case "DepartmentAdd":
                //     headerName = "部門新增"
                //     breadcrumbs = ["基礎設定", "職務權限管理", "公司組織管理"]
                //     content = <DepartmentAdd id={parameter} setIsLoading={setIsLoading} />
                //     break;
                case "DepartmentPositionAdd":
                    headerName = "職務新增"
                    breadcrumbs = ["基礎設定", "職務權限管理", "公司組織管理"]
                    content = <DepartmentPositionAdd id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "DepartmentPositionEdit":
                    headerName = "職務編輯"
                    breadcrumbs = ["基礎設定", "職務權限管理", "公司組織管理"]
                    content = <DepartmentPositionEdit id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "DepartmentPositionPermission":
                    headerName = "權限設定"
                    breadcrumbs = ["基礎設定", "職務權限管理", "公司組織管理"]
                    content = <DepartmentPositionPermission id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorResumeDetail":
                    headerName = "外派員工履歷表編輯"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "外派員工檢視"]
                    content = <ContractorResumeEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "ContractorResumeEdit":
                    headerName = "外派員工履歷表編輯"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "外派員工履歷表"]
                    content = <ContractorResumeEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "EmployeeResumeDetail":
                    headerName = "員工履歷表檢視"
                    breadcrumbs = ["資料庫管理", "員工資料庫", "員工履歷檢視"]
                    content = <EmployeeResumeEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "EmployeeResumeEdit":
                    headerName = "員工履歷表編輯"
                    breadcrumbs = ["資料庫管理", "員工資料庫", "員工履歷"]
                    content = <EmployeeResumeEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "CustomerContractDetail":
                    headerName = "廠商合約檢視"
                    breadcrumbs = ["資料庫管理", "廠商合約資料庫", "廠商合約管理"]
                    content = <CustomerContractEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "CustomerContractEdit":
                    headerName = "廠商合約編輯"
                    breadcrumbs = ["資料庫管理", "廠商合約資料庫", "廠商合約管理"]
                    content = <CustomerContractEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "CustomerPositionAdd":
                    headerName = "廠商合約新增"
                    breadcrumbs = ["資料庫管理", "廠商合約資料庫", "廠商合約管理"]
                    content = <CustomerPositionEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} />
                    break;
                case "CustomerPositionDetail":
                    headerName = "廠商合約編輯"
                    breadcrumbs = ["資料庫管理", "廠商合約資料庫", "廠商合約管理"]
                    content = <CustomerPositionEdit id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "CustomerPositionEdit":
                    headerName = "廠商合約編輯"
                    breadcrumbs = ["資料庫管理", "廠商合約資料庫", "廠商合約管理"]
                    content = <CustomerPositionEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "PositionDemandDetail":
                    headerName = "廠商合約編輯"
                    breadcrumbs = ["工作區", "招募主管", "職缺需求"]
                    content = <PositionDemandEdit id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={false} />
                    break;
                case "PositionDemandDetail_ML":
                    headerName = "廠商合約編輯"
                    breadcrumbs = ["工作區", "招募主管", "職缺需求"]
                    content = <PositionDemandEdit id={parameter} setIsLoading={setIsLoading} OnBoard={true} isEdit={true} isML={true} />
                    break;
                case "RecruitmentContractorStatusDetail":
                    headerName = "外派員工 工作狀態檢視 及預定作業"
                    breadcrumbs = ["工作區", "人力資料庫", "非就業中-外派員工"]
                    content = <RecruitmentContractorStatusDetail id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "RecruitmentContractorStatusDetail_ML":
                    headerName = "外派員工 工作狀態檢視 及預定作業"
                    breadcrumbs = ["工作區", "人力資料庫", "非就業中-外派員工"]
                    content = <RecruitmentContractorStatusDetail id={parameter} setIsLoading={setIsLoading} isML={true} />
                    break;
                case "RecruitmentContractorStatusDetail_All":
                    headerName = "外派員工 工作狀態檢視 及預定作業"
                    breadcrumbs = ["工作區", "人力資料庫", "非就業中-外派員工"]
                    content = <RecruitmentContractorStatusDetail id={parameter} setIsLoading={setIsLoading} isAll={true} />
                    break;
                case "ReserveSOP":
                    headerName = "外派員工預定標準作業程序(SOP)"
                    breadcrumbs = ["標準作業程序", "外派員工", "外派員工預定標準作業程序"]
                    content = <ReserveSOP id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "IsOrNotOnboardSOP":
                    headerName = "外派員工報到/未報到標準作業程序(SOP)"
                    breadcrumbs = ["標準作業程序", "外派員工", "外派員工報到/未報到標準作業程序"]
                    content = <IsOrNotOnboardSOP id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ResignSOP":
                    headerName = "外派員工離職標準作業程序(SOP)"
                    breadcrumbs = ["標準作業程序", "外派員工", "外派員工離職標準作業程序"]
                    content = <ResignSOP id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "InsuranceReviseSOP":
                    headerName = "外派員工 保險資訊修正作業"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "保險資訊修正作業"]
                    content = <InsuranceReviseSOP id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ReviseSOPCaseStatus1":
                    headerName = "外派員工 派遣案件修正作業"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "派遣案件修正作業"]
                    content = <ReviseSOPCaseStatus1 id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ReviseSOPCaseStatus2":
                    headerName = "外派員工 派遣案件修正作業"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "派遣案件修正作業"]
                    content = <ReviseSOPCaseStatus2 id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ReviseSOPCaseStatus3":
                    headerName = "外派員工 派遣案件修正作業"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "派遣案件修正作業"]
                    content = <ReviseSOPCaseStatus3 id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ReviseSOPCaseStatus4":
                    headerName = "外派員工 派遣案件修正作業"
                    breadcrumbs = ["資料庫管理", "外派員工資料庫", "派遣案件修正作業"]
                    content = <ReviseSOPCaseStatus4 id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorEnrollList":
                    headerName = "待加保-外派員工列表"
                    breadcrumbs = ["工作區", "保險管理", "加保管理"]
                    content = <ContractorEnrollList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorCancelList":
                    headerName = "待退保-外派員工列表"
                    breadcrumbs = ["工作區", "保險管理", "退保管理"]
                    content = <ContractorEnrollList id={parameter} setIsLoading={setIsLoading} isEnroll={false} />
                    break;
                case "ContractorAttendanceSOPList":
                    headerName = "外派員工-出勤登錄作業列表"
                    breadcrumbs = ["工作區", "會計作業管理", "外派員工-出勤登錄作業"]
                    content = <ContractorAttendanceSOPList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorAttendanceSOPAdd":
                    headerName = "外派員工-出勤登錄作業新增"
                    breadcrumbs = ["工作區", "會計作業管理", "外派員工-出勤登錄作業"]
                    content = <ContractorAttendanceSOPAdd setIsLoading={setIsLoading} />
                    break;
                case "ContractorAttendanceEdit":
                    headerName = "外派員工-出勤登錄作業編輯"
                    breadcrumbs = ["工作區", "會計作業管理", "外派員工-出勤登錄作業"]
                    content = <ContractorAttendanceEdit id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorAttendanceRegisterMonthly":
                    headerName = "外派員工-出勤及加減項登錄-月薪"
                    breadcrumbs = ["工作區", "會計作業管理", "外派員工-出勤登錄作業"]
                    content = <ContractorAttendanceRegisterMonthly id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorAttendanceRegisterHourly":
                    headerName = "外派員工-出勤及加減項登錄-時薪"
                    breadcrumbs = ["工作區", "會計作業管理", "外派員工-出勤登錄作業"]
                    content = <ContractorAttendanceRegisterHourly id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorAttendanceRegisterBonus":
                    headerName = "外派員工-出勤及加減項登錄-代招"
                    breadcrumbs = ["工作區", "會計作業管理", "外派員工-出勤登錄作業"]
                    content = <ContractorAttendanceRegisterHourly id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "ContractorInsuranceCostMonthly":
                    headerName = "外派員工-保費計算-"
                    breadcrumbs = ["工作區", "會計作業管理", "外派員工-出勤登錄作業"]
                    content = <ContractorInsuranceCost id={parameter} setIsLoading={setIsLoading} type={"Monthly"} />
                    break;
                case "ContractorInsuranceCostHourly":
                    headerName = "外派員工-保費計算-"
                    breadcrumbs = ["工作區", "會計作業管理", "外派員工-出勤登錄作業"]
                    content = <ContractorInsuranceCost id={parameter} setIsLoading={setIsLoading} type={"Hourly"} />
                    break;
                case "League_List":
                    headerName = "聯盟列表"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "聯盟資料管理"]
                    content = <LeagueList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "League_Add":
                    headerName = "聯盟新增"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "聯盟資料管理"]
                    content = <LeagueEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} />
                    break;
                case "League_Detail":
                    headerName = "聯盟檢視"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "聯盟資料管理"]
                    content = <LeagueEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "League_Edit":
                    headerName = "聯盟編輯"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "聯盟資料管理"]
                    content = <LeagueEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "UMP_List":
                    headerName = "主審列表"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "主審資料管理"]
                    content = <UMPList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "UMP_Add":
                    headerName = "主審新增"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "主審資料管理"]
                    content = <UMPEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} />
                    break;
                case "UMP_Detail":
                    headerName = "主審檢視"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "主審資料管理"]
                    content = <UMPEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "UMP_Edit":
                    headerName = "主審編輯"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "主審資料管理"]
                    content = <UMPEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "Park_List":
                    headerName = "球場列表"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球場資料管理"]
                    content = <ParkList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "Park_Add":
                    headerName = "球場新增"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球場資料管理"]
                    content = <ParkEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} />
                    break;
                case "Park_Detail":
                    headerName = "球場檢視"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球場資料管理"]
                    content = <ParkEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "Park_Edit":
                    headerName = "球場編輯"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球場資料管理"]
                    content = <ParkEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "Player_List":
                    headerName = "球員列表"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球員資料管理"]
                    content = <PlayerList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "Player_Add":
                    headerName = "球員新增"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球員資料管理"]
                    content = <PlayerEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} />
                    break;
                case "Player_Detail":
                    headerName = "球員檢視"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球員資料管理"]
                    content = <PlayerEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "Player_Edit":
                    headerName = "球員編輯"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球員資料管理"]
                    content = <PlayerEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "Team_List":
                    headerName = "球隊列表"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球隊資料管理"]
                    content = <TeamList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "Team_Add":
                    headerName = "球隊新增"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球隊資料管理"]
                    content = <TeamEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} />
                    break;
                case "Team_Detail":
                    headerName = "球隊檢視"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球隊資料管理"]
                    content = <TeamEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "Team_Edit":
                    headerName = "球隊編輯"
                    breadcrumbs = ["基礎設定", "基礎資料庫", "球隊資料管理"]
                    content = <TeamEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "Game_List":
                    headerName = "賽事列表"
                    breadcrumbs = ["賽事紀錄", "賽事紀錄資料庫", "賽事紀錄管理"]
                    content = <GameList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "Game_Add":
                    headerName = "賽事新增"
                    breadcrumbs = ["賽事紀錄", "賽事紀錄資料庫", "賽事紀錄管理"]
                    content = <GameEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} />
                    break;
                case "Game_Detail":
                    headerName = "賽事檢視"
                    breadcrumbs = ["賽事紀錄", "賽事紀錄資料庫", "賽事紀錄管理"]
                    content = <GameEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} />
                    break;
                case "Game_Edit":
                    headerName = "賽事編輯"
                    breadcrumbs = ["賽事紀錄", "賽事紀錄資料庫", "賽事紀錄管理"]
                    content = <GameEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "Action_List":
                    headerName = "Action List"
                    breadcrumbs = ["賽事紀錄", "賽事紀錄資料庫", "賽事紀錄管理"]
                    content = <ActionList id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "BallsModifyList":
                    headerName = "BallsModify List"
                    breadcrumbs = ["賽事紀錄", "賽事紀錄資料庫", "賽事逐球缺失修改"]
                    content = <BallModifyList id={parameter} setIsLoading={setIsLoading} />
                    break;
                case "Client_List":
                    headerName = "授權球隊列表"
                    breadcrumbs = ["外部會員管理", "外部會員資料庫", "授權球隊管理"]
                    content = <ClientList id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "Client_Add":
                    headerName = "授權球隊列表"
                    breadcrumbs = ["外部會員管理", "外部會員資料庫", "授權球隊管理"]
                    content = <ClientAdd id={parameter} setIsLoading={setIsLoading} isAdd={true} />
                    break;
                case "Client_Edit":
                    headerName = "授權球隊列表"
                    breadcrumbs = ["外部會員管理", "外部會員資料庫", "授權球隊管理"]
                    content = <ClientAdd id={parameter} setIsLoading={setIsLoading} isEdit={true} />
                    break;
                case "BeerRetail_List_M":
                    headerName = "客戶列表"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-業務主管"]
                    content = <RetailList id={parameter} setIsLoading={setIsLoading} purview={PURVIEW_MANAGER} />
                    break;
                case "BeerRetail_Add_M":
                    headerName = "客戶新增"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-業務主管"]
                    content = <RetailEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} purview={PURVIEW_MANAGER} />
                    break;
                case "BeerRetail_Detail_M":
                    headerName = "客戶檢視"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-業務主管"]
                    content = <RetailEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} purview={PURVIEW_MANAGER} />
                    break;
                case "BeerRetail_Edit_M":
                    headerName = "客戶編輯"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-業務主管"]
                    content = <RetailEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} purview={PURVIEW_MANAGER} />
                    break;
                case "BeerRetail_List_S":
                    headerName = "客戶列表"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-業務專頁"]
                    content = <RetailList id={parameter} setIsLoading={setIsLoading} purview={PURVIEW_SPECIALIST} />
                    break;
                case "BeerRetail_Add_S":
                    headerName = "客戶新增"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-業務專頁"]
                    content = <RetailEdit id={parameter} setIsLoading={setIsLoading} isAdd={true} isEdit={true} purview={PURVIEW_SPECIALIST} />
                    break;
                case "BeerRetail_Detail_S":
                    headerName = "客戶檢視"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-業務專頁"]
                    content = <RetailEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} purview={PURVIEW_SPECIALIST} />
                    break;
                case "BeerRetail_Edit_S":
                    headerName = "客戶編輯"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-業務專頁"]
                    content = <RetailEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} purview={PURVIEW_SPECIALIST} />
                    break;
                case "BeerRetail_List_D":
                    headerName = "客戶列表"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-經銷商"]
                    content = <RetailList id={parameter} setIsLoading={setIsLoading} purview={PURVIEW_DISTRIBUTOR} />
                    break;
                case "BeerRetail_Detail_D":
                    headerName = "客戶檢視"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-經銷商"]
                    content = <RetailEdit id={parameter} setIsLoading={setIsLoading} isEdit={false} purview={PURVIEW_DISTRIBUTOR} />
                    break;
                case "BeerRetail_Edit_D":
                    headerName = "客戶編輯"
                    breadcrumbs = ["資料庫管理", "酒業經銷客戶資料庫", "客戶管理-經銷商"]
                    content = <RetailEdit id={parameter} setIsLoading={setIsLoading} isEdit={true} purview={PURVIEW_DISTRIBUTOR} />
                    break;
                default:
                    content = <Blank />
                    break;
            }
        }
    }

    return (
        <>
            <ContentHeader headerName={headerName} headerDescription={headerDescription} breadcrumbs={breadcrumbs} />
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox m-b-sm">
                    </div>
                </div>
            </div>
            {content}
            <div className="row m-t-sm">
                <div className="col-lg-12">
                    <div className="ibox">
                    </div>
                </div>
            </div>
        </>
    )
}